import { render, staticRenderFns } from "./EditorBarButton.vue?vue&type=template&id=70025220&scoped=true&"
import script from "./EditorBarButton.vue?vue&type=script&lang=ts&"
export * from "./EditorBarButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70025220",
  null
  
)

export default component.exports